import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from '../../adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { SybaseCopySource } from 'app/model/pipeline/copysource/sybase.copysource';
import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { ValueAdapter } from '../../value.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SybaseCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*'
    }
})
export class SybaseCopySourceAdapter extends CopySourceAdapter<SybaseCopySource, Model.SybaseSource> {
    protected override async _toResource(copySource: SybaseCopySource): Promise<Model.SybaseSource> {
        const result: Model.SybaseSource = this.getCommonCopySourceProperties(
            copySource,
            Metamodel.modelFor(SybaseCopySource).name
        );
        if (copySource.mode === 'query') {
            result.query = ValueAdapter.toResource(copySource, SybaseCopySource.READER_QUERY);
        }
        return result;
    }

    protected override async _toModel(
        resource: Model.SybaseSource,
        copyActivity: CopyActivity
    ): Promise<SybaseCopySource> {
        return this._toTabularModel(resource, copyActivity, SybaseCopySource.MODEL);
    }
}
